import { useEffect } from 'react';
import { usePageMeta, type BreadcrumbItem } from '../components/layout/PageMeta';

/**
 * Sets the page title and breadcrumbs in the Topbar.
 * Serializes breadcrumbs to compare by value so callers don't need to memoize.
 *
 * @example
 * // Simple page
 * useSetPageMeta('Users', [{ label: 'Users' }]);
 *
 * // Detail page with link back
 * useSetPageMeta('John Doe', [{ label: 'Users', path: '/users' }, { label: 'John Doe' }]);
 */
export function useSetPageMeta(title: string, breadcrumbs: BreadcrumbItem[]) {
	const { setPageMeta } = usePageMeta();
	const key = title + '|' + JSON.stringify(breadcrumbs);

	useEffect(() => {
		setPageMeta(title, breadcrumbs);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [key, setPageMeta]);
}
